var map = {
	"./icon_AAPL.png": "a21a",
	"./icon_AMZN.png": "6e56",
	"./icon_AUDUSD.png": "93c6",
	"./icon_AUDUSD_m.png": "26f1",
	"./icon_D30EUR.png": "2f39",
	"./icon_EURUSD.png": "f583",
	"./icon_EURUSD_m.png": "b778",
	"./icon_GBPUSD.png": "7345",
	"./icon_GBPUSD_m.png": "e4c1",
	"./icon_MSFT.png": "65c8",
	"./icon_NASUSD.png": "4981",
	"./icon_NZDUSD.png": "02fc",
	"./icon_SPXUSD.png": "9f85",
	"./icon_TSLA.png": "a530",
	"./icon_U30USD.png": "e148",
	"./icon_USDJPY.png": "947a",
	"./icon_USDJPY_m.png": "9fd4",
	"./icon_XAGUSD.png": "ca26",
	"./icon_XAUUSD.png": "6260",
	"./icon_XBRUSD.png": "7533",
	"./icon_XNGUSD.png": "f576"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23fa";